import React from "react";
import { LegalPage } from "./LegalPage";
import { PRIVACY } from "../data/legalContent";

export default function Datenschutz() {
  return <LegalPage data={PRIVACY} path="/datenschutz" testId="datenschutz-page" />;
}
